import { returnErrors } from "./errorAction";
import {getJobApiCall, postJobApiCall, putJobApiCall } from "../../utils/jobRequest";
import { handle403Logout } from "../../utils/request";
import { CREATE_AUTOMATION, GET_ACTIONS_DATA, GET_AUTOMATION_APP_DATA, GET_AUTOMATION_DATA, GET_TRIGGERS_DATA, POST_LINK, POST_NODE } from "../Types/types";

// Get automation app details
export const getAutomationApp = (params) => async (dispatch) => {
  try {
    const toQueryString = (params) => "?" + new URLSearchParams(params).toString();
    const query = toQueryString(params);
    const response = await getJobApiCall(`automations/apps${query}`);
    if (response?.status === 200) {
      dispatch({ type: GET_AUTOMATION_APP_DATA, payload: response.data.data });
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to get automation app details", error?.response?.status);
  }
};

//Get automation list
export const getAutomation = (params) => async (dispatch) => {
    try {
      const toQueryString = (params) => "?" + new URLSearchParams(params).toString();
        const query = toQueryString(params);
        const response = await getJobApiCall(`automations/${query}`);
        if (response?.status === 200) {
            dispatch({ type: GET_AUTOMATION_DATA, payload: response.data.data });
        } else {
            returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors( dispatch, error?.response?.data?.message || "Failed to get automation details", error?.response?.status);
    }
}

//Get trigger list
export const getTrigger = () => async (dispatch) => {
  try {
    const response = await getJobApiCall(`automations/triggers`);
    if (response?.status === 200) {
      dispatch({ type: GET_TRIGGERS_DATA, payload: response.data.data });
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to get trigger details", error?.response?.status);
  }
}

//Get action list
export const getAction = () => async (dispatch) => {
  try {
    const response = await getJobApiCall(`automations/actions`);
    if (response?.status === 200) {
      dispatch({ type: GET_ACTIONS_DATA, payload: response.data.data });
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to get action details", error?.response?.status);
  }
}

//Create automation
export const createAutomations = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`automations/`, payload)
    if (response?.status === 200) {
      const data = response.data.data;
      dispatch({ type: CREATE_AUTOMATION, data });
      return data;
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to create node", error?.response?.status);
  }
}

//Save automation node
export const postAutomationNodes = (automation_id, payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`automations/${automation_id}/nodes`, payload);
    if (response?.status === 200) {
      dispatch({ type: POST_NODE, payload: response.data.data });
      return response.data.data;
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to create node", error?.response?.status);
  }
}

//Save automation link
export const postAutomationLink = (automation_id, payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`automations/${automation_id}/links`, payload);
    if (response?.status === 200) {
      dispatch({ type: POST_LINK, payload: response.data.data });
      return response.data.data;
    } else {
      returnErrors( dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to create link", error?.response?.status);
  }
}

// Update automation
export const updateAutomation = (automation_id, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`automations/${automation_id}`, payload);
    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to update automation", error?.response?.status);
  }
};

// Get automation details by ID
export const getAutomationById = (automation_id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`automations/${automation_id}`);

    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors( dispatch, error?.response?.data?.message || "Failed to fetch automation by ID", error?.response?.status);
  }
};

// Update an existing automation node (position, config, etc.)
export const updateAutomationNode = (automation_id, node_id, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`automations/${automation_id}/nodes/${node_id}`, payload);
    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to update node", error?.response?.status);
  }
};

// Update an existing automation link (condition, etc.)
export const updateAutomationLink = (automation_id, link_id, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`automations/${automation_id}/links/${link_id}`, payload);
    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to update link", error?.response?.status);
  }
};

// Deactivate (soft-delete) an automation node
export const deactivateNode = (automation_id, node_id) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`automations/${automation_id}/nodes/${node_id}`, { is_active: false });
    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to deactivate node", error?.response?.status);
  }
};

// Deactivate (soft-delete) an automation link
export const deactivateLink = (automation_id, link_id) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`automations/${automation_id}/links/${link_id}`, { is_active: false });
    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to deactivate link", error?.response?.status);
  }
};

// Trigger automation run status update
export const triggerAutomationRun = (automation_id, status) => async (dispatch) => {
  try {
    const payload = {
      status: status,
      input_payload: null
    };

    const response = await postJobApiCall(`automations/${automation_id}/runs`, payload);

    if (response?.status === 200) {
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to trigger automation run", error?.response?.status);
  }
};